export default "__VITE_ASSET__Bp6YFt0F__"